import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { CalculatorProjectService } from './services/api/calculator';
import { EditProjectContract } from './services/api/edit';
import { EditProjectService } from './services/api/edit/edit-project.service';
import { SaneProjectContract, SaneProjectService } from './services/api/projects';
import { ResumeTotalService } from './services/api/resume/resume-total.service';
import { SharedService } from './services/api/shared/shared.service';
import { ElectronicSignatureContract, ElectronicSignatureService } from './services/api/signature';

export function provideCoreServices(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: CalculatorProjectService, useClass: CalculatorProjectService },
    { provide: EditProjectContract, useClass: EditProjectService },
    { provide: SaneProjectContract, useClass: SaneProjectService },
    { provide: ResumeTotalService, useClass: ResumeTotalService },
    { provide: SharedService, useClass: SharedService },
    { provide: ElectronicSignatureContract, useClass: ElectronicSignatureService }
  ]);
}
